// extracted by mini-css-extract-plugin
module.exports = {"actions":"CorrectionsDetails_actions__3iK1r"};